import { AxiosResponse } from 'axios';
import { InspectionResolvedResponse } from '../features/AssetGrid/types/inspection.types';
import inspectionApi from '../apis/inspection.management.api';

export const getInspections = (
	assetId: string,
): Promise<AxiosResponse<InspectionResolvedResponse>> => {
	const address = `/inspections/${encodeURIComponent(assetId)}`;
	return inspectionApi.get(address);
};
